<section class="section why-choose-us" style="margin: 5rem 0">
  <div class="container">


    <div class="row justify-content-center col-12">
      <h2 class="header-text">OUR INDUSTRY EXPERIENCE SPAN</h2>
    </div>


    <div class="row justify-content-center">
      <div class="col-lg-2 col-md-3 com-sm-12 col-xs-12 text-center justify-content-center align-self-center">
        <div class="box py-5">
          <img src="/assets/images/banking.svg" height="30" />
          <div class="box-title">
            <h3 class="box-text mt-3">Finance</h3>
            <br />
          </div>
        </div>
      </div>
      <div class="col-lg-2 col-md-3 com-sm-12 col-xs-12 text-center justify-content-center align-self-center">
        <div class="box py-5">
          <img src="/assets/images/services-icons/manufacturing.svg" height="30" />
          <div class="box-title">
            <h3 class="box-text mt-3">Manufacturing</h3>
            <br />
          </div>
        </div>
      </div>
      <div class="col-lg-2 col-md-3 com-sm-12 col-xs-12 text-center justify-content-center align-self-center">
        <div class="box">
          <img src="/assets/images/services-icons/chat.svg" height="30" />
          <div class="box-title">
            <h3 class="box-text mt-3">Communications & Media Technology</h3>
          </div>
        </div>
      </div>
      <div class="col-lg-2 col-md-3 com-sm-12 col-xs-12 text-center justify-content-center align-self-center">
        <div class="box-sm">
          <img src="/assets/images/services-icons/user.svg" height="30" />
          <div class="box-title">
            <h3 class="box-text mt-3">Consumer
              Business Unit</h3>
          </div>
        </div>
      </div>
      <div class="col-lg-2 col-md-3 com-sm-12 col-xs-12 text-center justify-content-center align-self-center">
        <div class="box-lg">
          <img src="/assets/images/services-icons/energy.svg" height="30" />
          <div class="box-title">
            <h3 class="box-text mt-3">Energy, Natural Resources & Utilities</h3>
          </div>
        </div>
      </div>
    </div>


    <div class="row justify-content-center">
      <div class="col-lg-2 col-md-3 com-sm-12 col-xs-12 text-center justify-content-center align-self-center">
        <div class="box py-5">
          <img src="/assets/images/services-icons/life-sciences.svg" height="30" />
          <div class="box-title">
            <h3 class="box-text mt-3">Healthcare
              & Life Sciences</h3>
          </div>
        </div>
      </div>
      <div class="col-lg-2 col-md-3 com-sm-12 col-xs-12 text-center justify-content-center align-self-center">
        <div class="box py-5">
          <img src="/assets/images/services-icons/ecommerce.svg" height="30" />
          <div class="box-title">
            <h3 class="box-text mt-3">E-Commerce</h3>
          </div>
        </div>
      </div>
      <div class="col-lg-2 col-md-3 com-sm-12 col-xs-12 text-center justify-content-center align-self-center">
        <div class="box">
          <img src="/assets/images/services-icons/insurance.svg" height="30" />
          <div class="box-title">
            <h3 class="box-text mt-3">Insurance</h3>
            <br />
          </div>
        </div>
      </div>
      <div class="col-lg-2 col-md-3 com-sm-12 col-xs-12 text-center justify-content-center align-self-center">
        <div class="box-sm">
          <img src="/assets/images/services-icons/distribution.svg" height="30" />
          <div class="box-title">
            <h3 class="box-text mt-3">Consumer Goods
              & Distribution</h3>
          </div>
        </div>
      </div>
      <div class="col-lg-2 col-md-3 com-sm-12 col-xs-12 text-center justify-content-center align-self-center">
        <div class="box-lg">
          <img src="/assets/images/services-icons/compass.svg" height="30" />
          <div class="box-title">
            <h3 class="box-text mt-3">Travel, Transportation & Hospitality</h3>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
